import moment from 'moment';
// Convert a moment.js object to local time
export function convertToLocalMoment(utcTimeMoment, localTimezone) {
  return utcTimeMoment.utcOffset(localTimezone).add(localTimezone, 'hours').local();
}

export function getRemainingSecond(utc) {
  let remainingSeonds = 0;
  if (!!utc) {
    try {
      let expiryDate = moment.utc(utc);
      let now = moment().utc();
      remainingSeonds = expiryDate.diff(now, 'seconds');
      remainingSeonds = remainingSeonds >= 0 ? remainingSeonds : 0;
    } catch (err) {
      remainingSeonds = 0;
    }
  }
  return remainingSeonds;
}
